import React from 'react';

export const Computer = () => (
    <>
        <rect x='3' y='4' width='18' height='12' rx='1' />
        <line x1='7' y1='20' x2='17' y2='20' />
        <line x1='9' y1='16' x2='9' y2='20' />
        <line x1='15' y1='16' x2='15' y2='20' />
    </>
);